export default { title: 'Déposer un avis Google' };
